import MyMaorCheckout from "./MyMaorCheckout";

export default MyMaorCheckout;
